import React from 'react';

import { Popover } from 'antd';

import { formatMetricValue } from '@/shared/lib/utils/number';
import { EllipsisText } from '@/shared/ui/EllipsisText';

import styles from './MetricsSummary.module.css';

type MetricsSummaryProps = {
  metrics: Record<string, number> | null | undefined;
};

export const MetricsSummary: React.FC<MetricsSummaryProps> = ({ metrics }) => {
  if (!metrics || Object.keys(metrics).length === 0) {
    return <span>-</span>;
  }

  const entries = Object.entries(metrics);
  const first = entries[0];
  const remaining = entries.slice(1);

  if (entries.length === 1) {
    return (
      <div className={styles.container}>
        <span className={styles.key}>
          <EllipsisText text={`${first[0]}:`} />
        </span>
        <span className={styles.value}>{formatMetricValue(first[1])}</span>
      </div>
    );
  }

  const popoverContent = (
    <div className={styles.popoverContent}>
      {remaining.map(([key, value]) => {
        const displayValue = formatMetricValue(value);
        return (
          <div key={key} className={styles.itemRow}>
            <div className={styles.itemKey}>
              <EllipsisText text={key} />
            </div>
            <div className={styles.itemValue}>
              <EllipsisText text={displayValue} />
            </div>
          </div>
        );
      })}
    </div>
  );

  return (
    <div className={styles.container}>
      <span className={styles.key}>
        <EllipsisText text={`${first[0]}:`} />
      </span>
      <span className={styles.value}>{formatMetricValue(first[1])}, ...</span>
      <Popover content={popoverContent} trigger="hover" placement="top">
        <span className={styles.count}>+{remaining.length}</span>
      </Popover>
    </div>
  );
};
